import React from 'react';
import { Tooltip, IconButton } from '@mui/material';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import EditIcon from '@mui/icons-material/Edit';
import { calculateDebt, formatDateTime } from './functions';
import Level from '../sections/employee/order/order-details/tabs/ParticipanDetailsTab/Level';

export const orderColumns = handleDetailsCheck => [
  { field: 'Szczegóły',
    width: 50,
    align: 'center',
    disableClickEventBubbling: true,
    headerName: '',
    resizable: false,
    renderCell: params => (
      <Tooltip title="Szczegóły">
        <IconButton
          color="primary"
          onClick={() => handleDetailsCheck(params.row, true)}
        >
          <EditIcon />
        </IconButton>
      </Tooltip>
    ) },
  { field: 'reservation_date', headerName: 'Data rezerwacji', width: 160, hide: false, valueGetter: params => formatDateTime(params.row.created_at) },
  // { field: 'agreement_number', headerName: 'Numer umowy', width: 140, hide: false },
  { field: 'participant_name', headerName: 'Uczestnik', width: 140, hide: false },
  { field: 'debt', headerName: 'Zadłużenie', width: 140, align: 'center', hide: false, valueGetter: params => calculateDebt(params.row.order_payments) },
  { field: 'state_name', headerName: 'Status', width: 220, renderCell: params => <StateColumn params={params} />, hide: false },
  { field: 'event_name', headerName: 'Grupa', width: 140, hide: false },
  // { field: 'camp_name', headerName: 'Turnus', width: 140, hide: false },
  { field: 'resort_name', headerName: 'Ośrodek', width: 140, hide: false },
  // { field: 'sum_of_advances', headerName: 'Suma zaliczek', width: 140, hide: false },
  // { field: 'order_value', headerName: 'Wartość zamówienia', width: 140, hide: false },
  // { field: 'left_to_pay', headerName: 'Pozostało do zapłaty', width: 140, hide: false },
  // { field: 'transport_departure_description', headerName: 'Wyjazd', width: 140, hide: false },
  // { field: 'transport_return_description', headerName: 'Powrót', width: 140, hide: false },
  // { field: 'promotion_name', headerName: 'Rabat', width: 140, hide: false },
  { field: 'participant_pesel', headerName: 'Pesel', width: 140, hide: false },
  // { field: 'pl_gender_name', headerName: 'Płeć', width: 140, hide: false },
  { field: 'guardian_name', headerName: 'Opiekun', width: 140, hide: false },
  { field: 'guardian_correspondence_email', headerName: 'Email', width: 140, hide: false },
  { field: 'level', headerName: 'Stopień', width: 220, renderCell: params => <LevelColumn params={params} />, hide: false, resizable: false },
  { field: 'guardian_phone', headerName: 'Numer telefonu', width: 140, hide: false },
  { field: 'identifier', headerName: 'Numer zamówienia', width: 140, hide: false }
  // { field: 'agreement_date', headerName: 'Data umowy', width: 140, hide: false },
  // { field: 'participant_birth_date', headerName: 'Data urodzenia', width: 160, hide: false },
  // { field: 'return_agreement', headerName: 'Zwrot umowy', width: 140, align: 'center', renderCell: params => <BooleanColumn params={params} />, hide: false },
  // { field: 'return_of_health_card', headerName: 'Zwrot karty zdrowia', width: 200, align: 'center', renderCell: params => <BooleanColumn params={params} />, hide: false },
  // { field: 'accommodated', headerName: 'Zakwaterowano', width: 160, align: 'center', renderCell: params => <BooleanColumn params={params} />, hide: false },
  // { field: 'has_invoice', headerName: 'Faktura', align: 'center', renderCell: params => <BooleanColumn params={params} />, hide: false },
  // { field: 'invoice_issued', headerName: 'Faktura wystawiona', width: 190, align: 'center', renderCell: params => <BooleanColumn params={params} />, hide: false },
  // { field: 'invoice_paid', headerName: 'Faktura zapłacona', width: 190, align: 'center', renderCell: params => <BooleanColumn params={params} />, hide: false },
  // { field: 'discounts_cancelled', headerName: 'Anulowano rabaty', width: 180, hide: false },
  // { field: 'advance_payment_date', headerName: 'Termin zaliczki', width: 160, hide: false },
  // { field: 'final_payment_date', headerName: 'Termin zapłaty końcowej', width: 240, hide: false }
];


export const participantColumns = handleDetailsCheck => [
  { field: 'Szczegóły',
    width: 50,
    align: 'center',
    disableClickEventBubbling: true,
    headerName: '',
    renderCell: params => (
      <Tooltip title="Szczegóły">
        <IconButton
          color="primary"
          onClick={() => handleDetailsCheck(params.row)}
        >
          <EditIcon />
        </IconButton>
      </Tooltip>
    ) },
  { field: 'name', headerName: 'Imię i nazwisko', width: 180, hide: false },
  { field: 'birth_date', headerName: 'Data urodzenia', width: 180, hide: false },
  { field: 'gender', headerName: 'Płeć', width: 140, hide: false, renderCell: params => params.value === 'boy' ? 'Chłopiec' : params.value === 'girl' ? 'Dziewczynka' : '' },
  { field: 'pesel', headerName: 'Pesel', width: 140, hide: false },
  { field: 'city', headerName: 'Miasto', width: 140, hide: false },
  { field: 'postal_code', headerName: 'Kod pocztowy', width: 160, hide: false },
  { field: 'street_address', headerName: 'Adres', width: 200, hide: false }
];

export const purchaserColumns = handleDetailsCheck => [
  { field: 'Szczegóły',
    width: 50,
    align: 'center',
    disableClickEventBubbling: true,
    headerName: '',
    renderCell: params => (
      <Tooltip title="Szczegóły">
        <IconButton
          color="primary"
          onClick={() => handleDetailsCheck(params.row)}
        >
          <EditIcon />
        </IconButton>
      </Tooltip>
    ) },
  { field: 'name', headerName: 'Imię i nazwisko', width: 180, hide: false },
  { field: 'phone', headerName: 'Numer telefonu', width: 160, hide: false },
  { field: 'correspondence_email', headerName: 'E-mail', width: 200, hide: false },
  { field: 'type', headerName: 'Rodzaj', width: 100, hide: false, renderCell: params => params.value === 'guardian' ? 'Opiekun' : params.value === 'contractor' ? 'Kontrahent' : '' },
  { field: 'city', headerName: 'Miasto', width: 140, hide: false },
  { field: 'postal_code', headerName: 'Kod pocztowy', width: 220, hide: false },
  { field: 'street_address', headerName: 'Adres', width: 200, hide: false },
  { field: 'nip', headerName: 'NIP', width: 140, hide: false }
];

export const resortColumns = handleDetailsCheck => [
  { field: 'Szczegóły',
    width: 50,
    align: 'center',
    disableClickEventBubbling: true,
    headerName: '',
    renderCell: params => (
      <Tooltip title="Szczegóły">
        <IconButton
          color="primary"
          onClick={() => handleDetailsCheck(params.row)}
        >
          <EditIcon />
        </IconButton>
      </Tooltip>
    ) },
  { field: 'name', headerName: 'Nazwa', width: 250, hide: false, flex: 1 }
];

export const campColumns = handleDetailsCheck => [
  { field: 'Szczegóły',
    width: 50,
    align: 'center',
    disableClickEventBubbling: true,
    headerName: '',
    renderCell: params => (
      <Tooltip title="Szczegóły">
        <IconButton
          color="primary"
          onClick={() => handleDetailsCheck(params.row)}
        >
          <EditIcon />
        </IconButton>
      </Tooltip>
    ) },
  { field: 'name', headerName: 'Nazwa', width: 250, hide: false, flex: 1 },
  { field: 'date_from', headerName: 'Data od', width: 140, hide: false },
  { field: 'date_to', headerName: 'Data do', width: 160, hide: false },
  { field: 'season_display', headerName: 'Sezon', width: 160, hide: false }
];

export const eventColumns = handleDetailsCheck => [
  { field: 'Szczegóły',
    width: 50,
    align: 'center',
    disableClickEventBubbling: true,
    headerName: '',
    renderCell: params => (
      <Tooltip title="Szczegóły">
        <IconButton
          color="primary"
          onClick={() => handleDetailsCheck(params.row)}
        >
          <EditIcon />
        </IconButton>
      </Tooltip>
    ) },
  { field: 'name', headerName: 'Nazwa', flex: 1, hide: false },
  { field: 'gross_value', headerName: 'Cena (zł)', width: 200, hide: false },
  { field: 'resort_display', headerName: 'Ośrodek', flex: 1, hide: false },
  { field: 'for_children', headerName: 'Dla dzieci', width: 85, hide: false, align: 'center', renderCell: params => <BooleanColumn params={params} /> },
  { field: 'levels', headerName: 'Stopnie', width: 75, hide: false, align: 'center', renderCell: params => <BooleanColumn params={params} /> }
];

export const accomodationColumns = handleDetailsCheck => [
  { field: 'Szczegóły',
    width: 50,
    align: 'center',
    disableClickEventBubbling: true,
    headerName: '',
    renderCell: params => (
      <Tooltip title="Szczegóły">
        <IconButton
          color="primary"
          onClick={() => handleDetailsCheck(params.row)}
        >
          <EditIcon />
        </IconButton>
      </Tooltip>
    ) },
  { field: 'name', headerName: 'Nazwa', width: 250, hide: false, flex: 1 },
  { field: 'seasons_display', headerName: 'Sezony', width: 200, hide: false, flex: 1 },
  { field: 'resorts_display', headerName: 'Ośrodki', width: 200, hide: false, flex: 1 }
];

export const ageRangeColumns = handleDetailsCheck => [
  { field: 'Szczegóły',
    width: 50,
    align: 'center',
    disableClickEventBubbling: true,
    headerName: '',
    renderCell: params => (
      <Tooltip title="Szczegóły">
        <IconButton
          color="primary"
          onClick={() => handleDetailsCheck(params.row)}
        >
          <EditIcon />
        </IconButton>
      </Tooltip>
    ) },
  { field: 'name', headerName: 'Nazwa', width: 250, hide: false, flex: 1 },
  { field: 'seasons_display', headerName: 'Sezony', width: 200, hide: false, flex: 1 },
  { field: 'resorts_display', headerName: 'Ośrodki', width: 200, hide: false, flex: 1 }
];

export const seasonColumns = handleDetailsCheck => [
  { field: 'Szczegóły',
    width: 50,
    align: 'center',
    disableClickEventBubbling: true,
    headerName: '',
    renderCell: params => (
      <Tooltip title="Szczegóły">
        <IconButton
          color="primary"
          onClick={() => handleDetailsCheck(params.row)}
        >
          <EditIcon />
        </IconButton>
      </Tooltip>
    ) },
  { field: 'identifier', headerName: 'Identyfikator', width: 250, hide: false, flex: 1 },
  { field: 'year', headerName: 'Rok', width: 250, hide: false, flex: 1 },
  { field: 'season_display', headerName: 'Sezon', width: 250, hide: false, flex: 1 }
];

export const promotionColumns = handleDetailsCheck => [
  { field: 'Szczegóły',
    width: 50,
    align: 'center',
    disableClickEventBubbling: true,
    headerName: '',
    renderCell: params => (
      <Tooltip title="Szczegóły">
        <IconButton
          color="primary"
          onClick={() => handleDetailsCheck(params.row)}
        >
          <EditIcon />
        </IconButton>
      </Tooltip>
    ) },
  { field: 'name', headerName: 'Nazwa', width: 250, hide: false },
  { field: 'gross_value', headerName: 'Wartość', width: 100, hide: false },
  { field: 'is_enabled', headerName: 'Aktywna', width: 120, hide: false, renderCell: params => <BooleanColumn params={params} /> },
  { field: 'season_display', headerName: 'Sezon', width: 120, hide: false },
  { field: 'is_connected_with_big_family_card', headerName: 'Poł. z kartą dużej rodziny', width: 150, hide: false, renderCell: params => <BooleanColumn params={params} /> },
  { field: 'is_big_family_card', headerName: 'Karta dużej rodziny', width: 150, hide: false, renderCell: params => <BooleanColumn params={params} /> },
  { field: 'discount_code', headerName: 'Kod promocyjny', width: 170, hide: false },
  { field: 'discount_code_from', headerName: 'Kod promocyjny od', width: 170, hide: false },
  { field: 'discount_code_to', headerName: 'Kod promocyjny do', width: 170, hide: false }
];

export const transportColumns = handleDetailsCheck => [
  { field: 'Szczegóły',
    width: 50,
    align: 'center',
    disableClickEventBubbling: true,
    headerName: '',
    renderCell: params => (
      <Tooltip title="Szczegóły">
        <IconButton
          color="primary"
          onClick={() => handleDetailsCheck(params.row)}
        >
          <EditIcon />
        </IconButton>
      </Tooltip>
    ) },
  { field: 'name', headerName: 'Nazwa', width: 250, hide: false, flex: 1 },
  { field: 'gross_value', headerName: 'Cena brutto (zł)', width: 200, hide: false },
  { field: 'seasons_display', headerName: 'Sezony', width: 200, hide: false, flex: 1 },
  { field: 'resorts_display', headerName: 'Ośrodki', width: 200, hide: false, flex: 1 }
];

export const documentColumns = () => [
  { field: 'number', headerName: 'Nr. dokumentu', width: 170, hide: false },
  { field: 'type_display', headerName: 'Typ', width: 140, hide: false },
  { field: 'order_number', headerName: 'Nr. zamówienia', width: 170, hide: false },
  { field: 'total_gross_value', headerName: 'Wartość brutto (zł)', width: 130, hide: false },
  { field: 'issue_date', headerName: 'Data wystawienia', width: 180, hide: false },
  { field: 'participant_name', headerName: 'Uczestnik', width: 150, hide: false },
  { field: 'agreement_number', headerName: 'Nr. umowy', width: 130, hide: false },
  { field: 'buyer_name', headerName: 'Kontrahent', width: 150, hide: false },
  { field: 'user_name', headerName: 'Wystawiający', width: 150, hide: false }
];

export const templateProductColumns = handleDetailsCheck => [
  { field: 'Szczegóły',
    width: 50,
    align: 'center',
    disableClickEventBubbling: true,
    headerName: '',
    renderCell: params => (
      <Tooltip title="Szczegóły">
        <IconButton
          color="primary"
          onClick={() => handleDetailsCheck(params.row)}
        >
          <EditIcon />
        </IconButton>
      </Tooltip>
    ) },
  { field: 'name', headerName: 'Nazwa', width: 250, hide: false },
  { field: 'quantity', headerName: 'Ilość', width: 90, hide: false },
  { field: 'vat_rate', headerName: 'VAT', width: 80, hide: false },
  { field: 'gross_price', headerName: 'Cena brutto (zł)', width: 170, hide: false },
  { field: 'net_price', headerName: 'Cena netto (zł)', width: 170, hide: false },
  { field: 'gross_value', headerName: 'Wartość brutto (zł)', width: 185, hide: false },
  { field: 'net_value', headerName: 'Wartość netto (zł)', width: 180, hide: false },
  { field: 'vat_amount', headerName: 'Wartość VAT (zł)', width: 180, hide: false }
];

export const BooleanColumn = props => {
  const { params } = props;

  return (
    <div
      className="d-flex justify-content-between align-items-center"
      style={{ cursor: 'pointer' }}
    >
      { params.value
        ? <FontAwesomeIcon
          icon={['fas', 'check']}
          color="green"
          size="xs"
        />
        : <FontAwesomeIcon
          icon={['fas', 'times']}
          color="red"
          size="xs"
        />
      }
    </div>
  );
};

export const StateColumn = props => {
  const { params } = props;

  return (
    <div
      style={
        {
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          width: '100%',
          height: '100%',
          cursor: 'pointer',
          backgroundColor: params.row.state_color,
          color: 'white',
          textAlign: 'center',
          fontWeight: 'bold',
          borderRadius: '4px'
        }}
    >
      <p>{params.value}</p>
    </div>
  );
};

export const LevelColumn = props => {
  const { params } = props;

  if (!params.row.levels) {
    return null;
  }

  return (
    <Level levelDetails={params.row.level_details} sx={{ width: '100%', height: '100%' }}/>
  );
};
